import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  fetchMenuItemsRequest,
  fetchMenuItemsSuccess,
  fetchMenuItemsFailure,
} from '../slices/menuItemsSlice';
import type { MenuResponse } from '../../components/menuItems/types';
import { ENDPOINTS } from '../../api/endPoints';

function* fetchMenuItemsSaga(
  action: PayloadAction<{ restaurantId: string }>
): Generator<any, void, any> {
  try {
    const { restaurantId } = action.payload;
    
    // Fetch menu items with restaurant-id header
    const response = yield call(
      axios.get,
      ENDPOINTS.menu,
      {
        headers: {
          'restaurant-id': restaurantId
        }
      }
    );

    const menuData: MenuResponse = response.data;

    // Map response data to include pk_id for backward compatibility
    const mappedItems = (menuData.data || []).map(item => ({
      ...item,
      pk_id: item.id, // Map id to pk_id for existing components
    }));

    // Dispatch success with menu items
    yield put(fetchMenuItemsSuccess(mappedItems));
  } catch (error: any) {
    yield put(
      fetchMenuItemsFailure(
        error.response?.data?.message || error.message || 'Failed to fetch menu items'
      )
    );
  }
}

export function* menuItemsSaga() {
  yield takeLatest(fetchMenuItemsRequest.type, fetchMenuItemsSaga);
}
